import moment from "moment";
import { routeConfigCommon, routeConfigCustomer } from "routes/RouteConfig";
import { emailReg, mobileNumberReg } from "./Regex";
import ErrorMessage from "components/error/ErrorMessage";
import { load } from "@cashfreepayments/cashfree-js";

export const getCurrentUser = () => {
  let user = null;
  try {
    user =
      localStorage.getItem("token") != null
        ? localStorage.getItem("token")
        : null;
  } catch (error) {
    user = null;
  }
  return user;
};

export const setCurrentUser = (user) => {
  try {
    if (user) {
      return user.data;
    } else {
      return user;
    }
  } catch (error) {
    return error;
  }
};

export const handleValidationForm = (data) => {
  let formIsValid = true;
  let errorVal = {};
  const emailRegex = emailReg;
  const mobileRegex = mobileNumberReg;
  let keys = Object.keys(data);
  keys.forEach((type, idx) => {
    // Prevent empty spaces at the beginning of the input
    if (typeof data[type] === "string" && data[type].startsWith(" ")) {
      formIsValid = false;
      errorVal[type] = (
        <ErrorMessage errorMessage={'Cannot start with an empty space'} />
      );
      return;
    }  
    switch (type) {
      case "mobileOrEmail":
        //check input validation
        if (type === "mobileOrEmail" && data[type]?.length !== 10) {
          if (emailRegex.test(data[type])) {
            errorVal[type] = "";
          } else {
            formIsValid = false;
            errorVal[type] = (
              <ErrorMessage errorMessage={'Email or Mobile is incorrect'} />
            );
          }
        } else if (data[type]?.length === 10) {
          if (Number(data[type])) {
            errorVal[type] = "";
          } else {
            formIsValid = false;
            errorVal[type] = (
              <ErrorMessage errorMessage={'Email or Mobile is incorrect'} />
            );
          }
        } else {
          errorVal[type] = "";
        }
        break;
      case "firstname":
        //check input validation
        if (type === "firstname" && data[type]?.length === 30) {
          formIsValid = false;
          errorVal[type] = (
            <ErrorMessage errorMessage={'Name must contain 30 characters'} />
          );
        } else {
          errorVal[type] = "";
        }
        break;
      case "gender":
          if (data[type] === ''|| !data[type] ) {
            formIsValid = false;
            errorVal[type] = (
            <ErrorMessage errorMessage={'This field is required'} />
            );
          } 
          else {
            errorVal[type] = "";
          }
          return { formIsValid, errorVal };
      case "mobile": case "number":
        //check input validation
        if(data[type] === "e") {
          data[type] = 0
        }
        if (data[type]?.length !== 10) {
          formIsValid = false;
          errorVal[type] = (
              <ErrorMessage errorMessage={'Mobile number is incorrect'} />
          );
        } else if (data[type]?.length === 10) {
          if (Number(data[type])) {
          } else {
            formIsValid = false;
            errorVal[type] = (
              <ErrorMessage errorMessage={'Mobile number is incorrect'} />
            );
          }
        } else {
          errorVal[type] = "";
        }
        break;
      case "email":
        //check input validation
        if (type === "email" && emailRegex.test(data[type]) ) {
          errorVal[type] = "";
        } 
        else if(data[type]?.length === 50){
          if (emailRegex.test(data[type])) {
          } else {
            formIsValid = false;
            errorVal[type] = (
              <ErrorMessage errorMessage={'Email  should have 50 characters'}/>
            );
          }
        }
        else {
          formIsValid = false;
          errorVal[type] = (
            <ErrorMessage errorMessage={'Enter a valid email address'} />
          );
        }
        break;
      default:
        formIsValid = true;
        errorVal = {};
    }

    // Check if required is false and length is 0
    if (!data[type] && data[type]?.length === 0) {
      errorVal[type] = "";
    }
  });

  return { formIsValid, errorVal };
};

export const appRoot = "/app";

export const isAuthUsers = (path) => {  
  let isAuth = false;
  const role = 'customer'
  let routeConfig = routeConfigCommon;
  if (role === "customer") {
    routeConfig = routeConfigCommon.concat(routeConfigCustomer);
  }
  routeConfig.forEach((route) => {
    if (route.path === path) {
      isAuth = route.isAuth;
    }
    return isAuth;
  });

  return isAuth;
};

export const truncateComment = (comment, wordLimit) => {
  if (comment?.length > wordLimit) {
    return comment.slice(0, wordLimit) + "...";
  } else {
    return comment;
  }
};

export const dateFormate = (date, dFormate) => {
  if(dFormate === 'calendar'){
    return moment(date).calendar()
  }else{
    return moment(date).format(dFormate)
  }
  
};

export const cashfree = await load({
  mode:"sandbox" //or production || sandbox
});

// Convert time to hours and minutes
export const convertDecimalToTime = (decimal) => {
  const totalMinutes = decimal * 60;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = Math.round(totalMinutes % 60);
  
  return { hours, minutes };
};